var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchTable',_vm._b({attrs:{"items":_vm.items},on:{"saveItem":_vm.saveItem,"deleteItem":_vm.deleteItem,"reloadItems":_vm.loadItems}},'SearchTable',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }